import React, { useState } from 'react';
import '../../pages/AdminPortal/AdminPortal.css';
import { env } from '../../../../config/env';
import { resolveApiBaseForPath } from '../../../../shared/api/requestRouting';

const API_BASE = process.env.REACT_APP_API_URL || env.apiBase || '';
const ADMIN_LOGIN_PATH = '/v1/auth/admin/login';

export default function AdminLogin({ onLogin }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const targetBase = resolveApiBaseForPath(API_BASE, ADMIN_LOGIN_PATH);
            const res = await fetch(`${targetBase}${ADMIN_LOGIN_PATH}`, {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password }),
            });
            const data = await res.json();
            if (!res.ok) {
                setError(data?.message || 'Invalid credentials');
                setLoading(false);
                return;
            }
            onLogin(data?.data || null);
        } catch (err) {
            setError('Network error. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-login-page">
            <form className="admin-login-card" onSubmit={handleSubmit}>
                <h1>Z<span className="brand-q">o</span>pe<span className="brand-q">o</span> Admin</h1>
                <p className="subtitle">Internal portal — team access only</p>
                {error && <div className="error">{error}</div>}
                <div className="admin-field">
                    <label>Email</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="admin@zopeo.in"
                        required
                        autoFocus
                    />
                </div>
                <div className="admin-field">
                    <label>Password</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="••••••••"
                        required
                    />
                </div>
                <button className="admin-btn admin-btn-primary" type="submit" disabled={loading}>
                    {loading ? 'Signing in…' : 'Sign in'}
                </button>
            </form>
        </div>
    );
}
